import type {Price} from '@/redux/v1/models';

import {useMountEffect} from '@react-hookz/web';
import {useTranslation} from 'react-i18next';

import {CrossBorderBannerV1} from '@/components/CrossBorderBannerV1';
import {CrossBorderBannerV2} from '@/components/CrossBorderBannerV2';
import {useTracking} from '@/modules/common/hooks/useTracking';

type Props = {
  version: 1 | 2;
  url: string;
  airports: Array<string>;
  price: Price;
  priceEnabled: boolean;
};

export const CrossBorderBanner: React.FunctionComponent<Props> = ({
  version,
  url,
  airports,
  price,
  priceEnabled,
}) => {
  const {t} = useTranslation('airportsWidget');
  const {dispatchGenericTrackingEvent} = useTracking();
  const airportNames = airports.map((code) => t(`options.${code}.name`));

  const handleClick = () =>
    dispatchGenericTrackingEvent({
      event: 'cross_border',
      event_action: 'banner_clicked',
      non_interaction: false,
      crb_bannertype: priceEnabled
        ? 'button_with_price'
        : 'button_without_price',
    });

  useMountEffect(() => {
    dispatchGenericTrackingEvent({
      event: 'cross_border',
      event_action: 'banner_shown',
      non_interaction: true,
      crb_bannertype: priceEnabled
        ? 'button_with_price'
        : 'button_without_price',
    });
  });

  if (version === 1) {
    return (
      <CrossBorderBannerV1
        url={url}
        airports={airportNames}
        price={price}
        priceEnabled={priceEnabled}
        onClick={handleClick}
      />
    );
  }

  return (
    <CrossBorderBannerV2
      url={url}
      airports={airportNames}
      onClick={handleClick}
    />
  );
};
